
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)  // 必须注册插件

export default new Vuex.Store({
  state: {    // 定义全局状态
    user: null,
    counter: 0
  },
  mutations: {  // 同步修改状态
    setUser(state, payload) {
      state.user = payload
    },
    increment(state) {
      state.counter++
    }
  },
  actions: {   // 异步操作
    async fetchUser({ commit }, userId) {
      const user = await api.getUser(userId)
      commit('setUser', user)
    }
  },
  getters: {   // 计算属性
    isLoggedIn: state => !!state.user
  },
  modules: {}  // 模块化分割
})
